import React, { createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
// Preload LCP image immediately to eliminate resource load delay
const preloadLink = document.createElement('link');
preloadLink.rel = 'preload';
preloadLink.as = 'image';
preloadLink.href = 'https://cdn.magicpatterns.com/uploads/8BymP3xMsw4RGti6Va9zF6/mockup_premium_2.webp';
preloadLink.type = 'image/webp';
document.head.appendChild(preloadLink);
render(<App data-id="element-271" />, document.getElementById('root'));
// Load Meta Pixel after page is fully idle (non-blocking, deferred)
if (typeof window !== 'undefined') {
  const loadPixel = () => {
    const script = document.createElement('script');
    script.async = true;
    script.innerHTML = `
      !function(f,b,e,v,n,t,s){
        if(f.fbq)return;
        n=f.fbq=function(){n.callMethod?
        n.callMethod.apply(n,arguments):n.queue.push(arguments)};
        if(!f._fbq)f._fbq=n;
        n.push=n;n.loaded=!0;n.version='2.0';
        n.queue=[];
        t=b.createElement(e);t.async=!0;
        t.src=v;
        s=b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t,s)
      }(window, document,'script','https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', '1688179945683486');
      fbq('track', 'PageView');
    `;
    document.head.appendChild(script);
  };
  // Use requestIdleCallback if available, otherwise fallback to 5s timeout
  if ('requestIdleCallback' in window) {
    ;
    (window as any).requestIdleCallback(loadPixel, {
      timeout: 5000
    });
  } else {
    setTimeout(loadPixel, 5000);
  }
}